/* queued.icon.svg.js */

module.exports = {
    icon: `
            <svg viewBox="0 0 18.5 16" preserveAspectRatio="none">
                <path class="foreground-gl" d="M12.3,11H6.5c-0.5,0-0.9-0.4-0.9-0.9V10c0-0.5,0.4-0.9,0.9-0.9h5.8c0.5,0,0.9,0.4,0.9,0.9v0.2
                    C13.1,10.6,12.7,11,12.3,11z"/>
                <path class="foreground-gl" d="M12.3,6.9H6.5C6,6.9,5.6,6.5,5.6,6V5.9C5.6,5.4,6,5,6.5,5h5.8c0.5,0,0.9,0.4,0.9,0.9V6
                    C13.1,6.5,12.7,6.9,12.3,6.9z"/>
                <path class="foreground-gl" d="M18.4,3.6l-2.2-3.1c-0.1-0.1-0.4-0.1-0.5,0l-2.2,3.1c-0.2,0.2-0.1,0.6,0.3,0.6H15v9.9H9.2
                    c-0.4,0-0.8,0.4-0.8,0.8v0.3c0,0.4,0.4,0.8,0.8,0.8H15h0.1h0.8c0.5,0,0.9-0.4,0.9-0.9V4.2h1.3C18.5,4.2,18.6,3.8,18.4,3.6z"/>
                <path class="foreground-gl" d="M9.5,0H3.6c0,0,0,0,0,0c0,0,0,0-0.1,0H2.6C2.1,0,1.7,0.4,1.7,0.9v10.8H0.4c-0.3,0-0.5,0.4-0.3,0.6l2.2,3.1
                    c0.1,0.1,0.4,0.1,0.5,0L5,12.4c0.2-0.2,0.1-0.6-0.3-0.6H3.5V1.9c0,0,0,0,0,0c0,0,0,0,0.1,0h5.9c0.4,0,0.8-0.4,0.8-0.8V0.8
                    C10.3,0.4,9.9,0,9.5,0z"/>
            </svg>
        `
};
